export const handleAddPhotoToFormData = (props: {
  formData: FormData,
  propName: string,
  value: string | File | null,
}) => {
  const { value, propName, formData } = props;
  if (!value) {
    formData.append(propName, '');
  }
  if (value instanceof File) {
    formData.append(propName, value);
    return;
  }
};